import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'block',
      component: () => import(/* webpackChunkName: "block0" */ './block0')
    },
    {
      path: '/block0',
      name: 'block0',
      props: true,
      component: () => import(/* webpackChunkName: "block0" */ './block0')
    },
    {
      path: '/block1/:id?',
      name: 'block1',
      props: true,
      component: () => import(/* webpackChunkName: "block1" */ './block1')
    },
    {
      path: '/block2/:id?',
      name: 'block2',
      props: true,
      component: () => import(/* webpackChunkName: "block2" */ './block2')
    },
    {
      path: '/block3/:id?',
      name: 'block3',
      props: true,
      component: () => import(/* webpackChunkName: "block3" */ './block3')
    },
    {
      path: '/block4/:id?',
      name: 'block4',
      props: true,
      component: () => import(/* webpackChunkName: "block4" */ './block4')
    },
    {
      path: '/block5/:id?',
      name: 'block5',
      props: true,
      component: () => import(/* webpackChunkName: "block5" */ './block5')
    },
    {
      path: '/block6/:id?',
      name: 'block6',
      props: true,
      component: () => import(/* webpackChunkName: "block6" */ './block6')
    },
    // {
    //   path: '/block7/:id?',
    //   name: 'block7',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block7" */ './block7')
    // },
    {
      path: '/block8/:id?',
      name: 'block8',
      props: true,
      component: () => import(/* webpackChunkName: "block8" */ './block8')
    },
    {
      path: '/block9/:id?',
      name: 'block9',
      props: true,
      component: () => import(/* webpackChunkName: "block9" */ './block9')
    },
    {
      path: '/block10/:id?',
      name: 'block10',
      props: true,
      component: () => import(/* webpackChunkName: "block10" */ './block10')
    },
    {
      path: '/block11/:id?',
      name: 'block11',
      props: true,
      component: () => import(/* webpackChunkName: "block11" */ './block11')
    },
    {
      path: '/block12/:id?',
      name: 'block12',
      props: true,
      component: () => import(/* webpackChunkName: "block12" */ './block12')
    },
    {
      path: '/block13/:id?',
      name: 'block13',
      props: true,
      component: () => import(/* webpackChunkName: "block13" */ './block13')
    },
    {
      path: '/block14/:id?',
      name: 'block14',
      props: true,
      component: () => import(/* webpackChunkName: "block14" */ './block14')
    },
    {
      path: '/block15/:id?',
      name: 'block15',
      props: true,
      component: () => import(/* webpackChunkName: "block15" */ './block15')
    },
    {
      path: '/block16/:id?',
      name: 'block16',
      props: true,
      component: () => import(/* webpackChunkName: "block16" */ './block16')
    },
    {
      path: '/block17/:id?',
      name: 'block17',
      props: true,
      component: () => import(/* webpackChunkName: "block17" */ './block17')
    },
    {
      path: '/block18/:id?',
      name: 'block18',
      props: true,
      component: () => import(/* webpackChunkName: "block18" */ './block18')
    },
    {
      path: '/block19/:id?',
      name: 'block19',
      props: true,
      component: () => import(/* webpackChunkName: "block19" */ './block19')
    },
    {
      path: '/block20/:id?',
      name: 'block20',
      props: true,
      component: () => import(/* webpackChunkName: "block20" */ './block20')
    },
    {
      path: '/block20a/:id?',
      name: 'block20a',
      props: true,
      component: () => import(/* webpackChunkName: "block20a" */ './block20a')
    },
    {
      path: '/block20b/:id?',
      name: 'block20b',
      props: true,
      component: () => import(/* webpackChunkName: "block20b" */ './block20b')
    },
    {
      path: '/block20c/:id?',
      name: 'block20c',
      props: true,
      component: () => import(/* webpackChunkName: "block20c" */ './block20c')
    },
    {
      path: '/block24/:id?',
      name: 'block24',
      props: true,
      component: () => import(/* webpackChunkName: "block24" */ './block24')
    },
    {
      path: '/block25/:id?',
      name: 'block25',
      props: true,
      component: () => import(/* webpackChunkName: "block25" */ './block25')
    },
    {
      path: '/block26/:id?',
      name: 'block26',
      props: true,
      component: () => import(/* webpackChunkName: "block26" */ './block26')
    },
    {
      path: '/block27/:id?',
      name: 'block27',
      props: true,
      component: () => import(/* webpackChunkName: "block27" */ './block27')
    },
    {
      path: '/block29/:id?',
      name: 'block29',
      props: true,
      component: () => import(/* webpackChunkName: "block29" */ './block29')
    },
    {
      path: '/block30/:id?',
      name: 'block30',
      props: true,
      component: () => import(/* webpackChunkName: "block30" */ './block30')
    },
    {
      path: '/block30a/:id?',
      name: 'block30a',
      props: true,
      component: () => import(/* webpackChunkName: "block30a" */ './block30a')
    }, 
    {
      path: '/block31/:id?',
      name: 'block31',
      props: true,
      component: () => import(/* webpackChunkName: "block31" */ './block31')
    },
    {
      path: '/block31a/:id?',
      name: 'block31a',
      props: true,
      component: () => import(/* webpackChunkName: "block31a" */ './block31a')
    },
    {
      path: '/block32/:id?',
      name: 'block32',
      props: true,
      component: () => import(/* webpackChunkName: "block32" */ './block32')
    },
    {
      path: '/block33/:id?',
      name: 'block33',
      props: true,
      component: () => import(/* webpackChunkName: "block33" */ './block33')
    },
    {
      path: '/block34/:id?',
      name: 'block34',
      props: true,
      component: () => import(/* webpackChunkName: "block34" */ './block34')
    }, 
    {
      path: '/block35/:id?',
      name: 'block35',
      props: true,
      component: () => import(/* webpackChunkName: "block35" */ './block35')
    },
    {
      path: '/block36/:id?',
      name: 'block36',
      props: true,
      component: () => import(/* webpackChunkName: "block36" */ './block36')
    },
    {
      path: '/block37/:id?',
      name: 'block37',
      props: true,
      component: () => import(/* webpackChunkName: "block37" */ './block37')
    },
    {
      path: '/block38/:id?',
      name: 'block38',
      props: true,
      component: () => import(/* webpackChunkName: "block38" */ './block38')
    },
    {
      path: '/block39/:id?',
      name: 'block39',
      props: true,
      component: () => import(/* webpackChunkName: "block39" */ './block39')
    },
    {
      path: '/block40/:id?',
      name: 'block40',
      props: true,
      component: () => import(/* webpackChunkName: "block40" */ './block40')
    },
    {
      path: '/block41/:id?',
      name: 'block41',
      props: true,
      component: () => import(/* webpackChunkName: "block41" */ './block41')
    },
    {
      path: '/block42/:id?',
      name: 'block42',
      props: true,
      component: () => import(/* webpackChunkName: "block42" */ './block42')
    },
    {
      path: '/block43/:id?',
      name: 'block43',
      props: true,
      component: () => import(/* webpackChunkName: "block43" */ './block43')
    },
    // {
    //   path: '/block43a/:id?',
    //   name: 'block43a',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block43a" */ './block43a')
    // },
    {
      path: '/block44/:id?',
      name: 'block44',
      props: true,
      component: () => import(/* webpackChunkName: "block44" */ './block44')
    },
    {
      path: '/block45/:id?',
      name: 'block45',
      props: true,
      component: () => import(/* webpackChunkName: "block45" */ './block45')
    },
    // {
    //  path: '/block45a/:id?',
    //  name: 'block45a',
    //  props: true,
    //  component: () => import(/* webpackChunkName: "block45a" */ './block45a')
    //},
    {
      path: '/block45b/:id?',
      name: 'block45b',
      props: true,
      component: () => import(/* webpackChunkName: "block45b" */ './block45b')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "search" */ './search')
    },
    {
      path: '/block46/:id?',
      name: 'block46',
      props: true,
      component: () => import(/* webpackChunkName: "block46" */ './block46')
    // },
    // {
    //   path: '/block_demo/:id?',
    //   name: 'block_demo',
    //   props: true,
    //   component: () => import(/* webpackChunkName: "block_demo" */ './block_demo')
    }
  ]
})
